<template>
  <div class="page-content">
    <PageHeader title="应用管理">
      <div slot="extra">
        <el-button type="primary" @click="handleDetailAdd">+应用</el-button>
      </div>
    </PageHeader>
    <div class="page-scroll-box">
      <div class="filter-box">
        <el-row>
          <el-col :span="8" class="filter-item">
            <label class="label">应用名称</label>
            <el-select
              v-model="params.ids"
              placeholder="请选择应用名称"
              clearable
              multiple
              collapse-tags
              filterable
              @change="handleSearch"
            >
              <el-option
                v-for="item in optionsListApp"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" class="filter-item">
            <label class="label">行业</label>
            <el-cascader
              v-model="bindFilterCategoryIds"
              size="small"
              :options="detail.categoryList"
              :show-all-levels="false"
              :props="{ multiple: true, checkStrictly: true }"
              collapse-tags
              clearable
              class="app_cascader"
              placeholder="请选择行业"
              @change="handleSearch"
            />
          </el-col>
          <el-col :span="8" class="filter-item">
            <label class="label">操作系统</label>
            <el-select
              v-model="params.type"
              placeholder="请选择操作系统"
              clearable
              @change="handleSearch"
            >
              <el-option
                v-for="item in detail.typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" class="filter-item">
            <label class="label">审核状态</label>
            <el-select
              v-model="params.status"
              placeholder="请选择审核状态"
              clearable
              multiple
              collapse-tags
              @change="handleSearch"
            >
              <el-option
                v-for="item in optionsListStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      
      <ShowTable
        :listData="listData"
        :pageShow="true"
        :pageSize="params.page_size"
        @pageChange="pageChangeHandle"
        @pageSizeChange="pageSizeChangeHandle"
        @actionClick="handleClick"
      />
    </div>
    
    <!-- 新建&编辑 -->
    <el-dialog
      :title="`${detail.form.id ? '编辑' : '新建'}`"
      width="600px"
      :visible="detail.visible"
      :before-close="handleDetailClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="120px" ref="detail" :model="detail.form">
        <el-form-item
          label="媒体名称"
          prop="name"
          :rules="[
            { required: true, message: '请输入媒体名称', trigger: 'blur' },
            { max: 20, message: '20个字符以内', trigger: 'blur' },
            { pattern: /^[\u4E00-\u9FA5\w\d]+$/, message: '只能输入中文、英文字母、数字' }
          ]"
        >
          <el-input v-model="detail.form.name" size="small" placeholder="20个字符以内，请不要输入非法字符"></el-input>
        </el-form-item>
        <el-form-item label="媒体行业" prop="category_ids" :rules="[{ required: true, message: '请选择媒体行业' }]">
          <el-cascader
            v-model="bindCategoryIds"
            size="small"
            :options="detail.categoryList"
            :show-all-levels="false"
            :props="{ multiple: true, checkStrictly: true }"
            collapse-tags
            clearable
            class="app_cascader"
          />
        </el-form-item>
        <el-form-item label="客户端类型" prop="type" :rules="[{ required: true, message: '请选择客户端类型' }]">
          <el-select
            v-model="detail.form.type"
            size="small"
            placeholder="请选择客户端类型"
          >
            <el-option
              v-for="(v, i) in detail.typeList"
              :key="i"
              :label="v.label"
              :value="v.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="媒体日活" prop="dau" :rules="[{ required: true, message: '请输入媒体日活数据' }]">
          <el-input v-model="detail.form.dau" size="small" placeholder="请输入媒体日活数据"></el-input>
        </el-form-item>
        <el-form-item label="下载地址" prop="download_url" :rules="[{ pattern: /^(http|https):\/\/(\d|\w)+/, message: '下载地址以http/https开头' }]">
          <el-input v-model="detail.form.download_url" size="small" placeholder="请输入应用市场的下载地址"></el-input>
        </el-form-item>
        <el-form-item label="媒体简介">
          <el-input v-model="detail.form.comment" size="small" placeholder="请输入媒体介绍，100字以内"></el-input>
        </el-form-item>
        <el-form-item label="媒体包名" prop="package" :rules="[{ required: true, message: '请输入媒体包名' }]">
          <el-input v-model="detail.form.package" size="small" placeholder="请输入媒体包名" @change="handleCheckPackage"></el-input>
          <el-alert v-if="detail.packageRepeat" title="该包名已存在" type="error" style="padding: 0;"></el-alert>
        </el-form-item>
        <el-form-item label="Universal Link" prop="developer_ulk" v-if="detail.form.type === 3">
          <el-input v-model="detail.form.developer_ulk" size="small" placeholder="请输入Universal Link"></el-input>
        </el-form-item>
        <el-form-item label="媒体微信appid" prop="have_wx_appid" :rules="[{ required: true, message: '请选择是否有微信appid' }]" style="margin-bottom: 10px;">
          <el-radio-group v-model="detail.form.have_wx_appid">
            <el-radio
              v-for="(v, i) in detail.haveWxAppIdList"
              :key="i"
              :label="v.value"
            >{{ v.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="wx_appid" :rules="[{ required: true, message: '请输入媒体对应的微信appid' }]" v-if="detail.form.have_wx_appid">
          <el-input v-model="detail.form.wx_appid" size="small" placeholder="请输入媒体对应的微信appid"></el-input>
        </el-form-item>
        <el-form-item label="屏幕方向" prop="screen_ori" :rules="[{ required: true, message: '请选择屏幕方向' }]">
          <el-radio-group v-model="detail.form.screen_ori">
            <el-radio
              v-for="(v, i) in detail.screenOri"
              :key="i"
              :label="v.value"
            >{{ v.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--
        <el-form-item v-if="![3].includes(detail.form.type)" label="是否AndroidX" prop="sdk_version" :rules="[{ required: true, message: '请选择是否AndroidX' }]">
          <el-radio-group v-model="detail.form.sdk_version">
            <el-radio
              v-for="(v, i) in detail.sdkVersionList"
              :key="i"
              :label="v.value"
            >{{ v.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        -->
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleDetailClose">取消</el-button>
        <el-button size="small" type="primary" @click="handleDetailSave">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import ShowTable from '@/components/ShowTable';
import { getAppList, getAppAllList, getCategoryList, mediaAdd, mediaEdit, mediaCheckPackage } from '@/apis/flow.js';

export default {
  components: {
    PageHeader,
    ShowTable
  },
  
  data() {
    return {
      params: {
          ids: [],
          category_ids: [],
          type: '',
          status: [],
          page: 1,
          page_size: 20,
      },

      optionsListApp: [],
      optionsListStatus: [
        { label: '待审核', value: 2 },
        { label: '审核通过', value: 0 },
        { label: '审核驳回', value: 3 },
      ],
      
      listData: {
        head: [
          {
            key: 'name',
            name: '应用名称',
            align: 'center',
          },
          {
            key: 'id',
            name: '应用ID',
            align: 'center',
          },
          {
            key: 'screen_ori_name',
            name: '屏幕方向',
            align: 'center',
          },
          {
            key: 'category_names',
            name: '行业',
            align: 'center',
          },
          {
            key: 'type_name',
            name: '操作系统',
            align: 'center',
          },
          {
            key: 'status',
            name: '审核状态',
            align: 'center',
            options: {
              0: '审核通过',
              1: '下架',
              2: '待审核',
              3: '审核驳回'
            }
          },
          {
            key: 'action',
            name: '操作',
            type: 'action',
            width: '215px',
            align: 'center',
            actionList: [
              {
                key: 'edit',
                name: '编辑',
                disabled: (row) => {
                  return !row.status;
                }
              },
              {
                key: 'show',
                name: '查看代码位',
                disabled: (row) => {
                  return [1, 2, 3].includes(row.status);
                }
              },
              {
                key: 'add',
                name: '创建代码位',
                disabled: (row) => {
                  return [1, 2, 3].includes(row.status);
                }
              }
            ]
          },
        ],
        list: [],
        currentPage: 1,
        total: 0,
      },
      
      detail: {
        visible: false,
        categoryList: [],
        typeList: [{ label: 'Android', value: 1 }, { label: 'iOS', value: 3 }, { label: '鸿蒙', value: 5 }],
        sdkVersionList: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
        haveWxAppIdList: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
        screenOri: [{ label: '竖屏', value: 1 }, { label: '横屏', value: 2 }],
        form: {
          id: '',
          name: '', // 媒体名称
          category_ids: [], // 媒体行业
          type: '', // 客户端类型
          dau: '', // 媒体日活
          download_url: '', // 下载地址
          comment: '', // 媒体简介
          package: '', // 媒体包名
          developer_ulk: '', // Universal Link
          have_wx_appid: '',
          wx_appid: '', // 媒体微信appid
          screen_ori: '',
          // sdk_version: 0, // 是否AndroidX
        },
        packageRepeat: false
      }
    }
  },
  
  computed: {
    bindFilterCategoryIds: {
      get() {
        return this.params.category_ids;
      },
      set(val) {
        let v = [];
        if (val) v = val;
        this.params.category_ids = v;
      }
    },
    bindCategoryIds: {
      get() {
        return this.detail.form.category_ids;
      },
      set(val) {
        let v = [];
        if (val) v = val;
        this.detail.form.category_ids = v;
      }
    }
  },
  
  created() {
    this.getList();
    this.getAppAllList();
    this.getCategoryList();
  },
  
  methods: {
    async getCategoryList() {
      const res = await getCategoryList();
      if (res && res.code === 200) {
        this.detail.categoryList = res.data.options;
      }
    },

    async getList() {
      // const userInfo = this.$ls.get('userInfo');
      // if ((userInfo && userInfo.main_user) || (userInfo && userInfo.account_status !== 1)) return;
    
        let categoryIdsArr = [];
        this.params.category_ids.forEach(v => {
            if (v && v[1]) {
                categoryIdsArr.push(v[1]);
            } else {
                categoryIdsArr.push(v[0]);
            }
        });
        
      const { data = {} } = await getAppList({
          page: this.params.page,
          page_size: this.params.page_size,
          query_condition: {
              ids: this.params.ids.join(),
              category_ids: categoryIdsArr.join(),
              type: this.params.type,
              status: this.params.status.join(),
          }
      });
      
      data.list.map(v => {
        // 屏幕方向
        v['screen_ori_name'] = this.detail.screenOri.find(i => i.value === v.screen_ori).label;
      });
      
      this.$set(this.listData, 'list', data.list)
      this.$set(this.listData, 'total', data.total)
      this.$set(this.listData, 'currentPage', this.params.page)
    },
    handleSearch() {
        this.getList();
    },
  
    async getAppAllList() {
        const res = await getAppAllList({
            page: 1,
            page_size: 999
        });
        if (res && res.code === 200) {
            this.optionsListApp = res.data.list || [];
        }
    },
    pageChangeHandle(page) {
      this.params.page = page;
      this.getList();
    },
    pageSizeChangeHandle(size) {
      this.params.page_size = size;
      this.params.page = 1;
      this.getList();
    },
    handleClick(btn, row) {
      const key = btn.key;
      switch(key) {
        case 'edit':
          this.handleDetailEdit(row);
          break;
        case 'add':
          this.$router.push({
            name: 'codeAdd',
            query: {
              appId: row.id,
              appName: row.name,
            }
          })
          break;
        case 'show':
          this.$ls.set('appName', row.name)
          this.$router.push({
            name: 'codeList',
            query: {
              appId: row.id,
              appName: row.name,
            }
          })
          break;
        default:
          break;
      }
    },
  
    async handleCheckPackage(cont) {
      if (!this.detail.form.type) return;
      const res = await mediaCheckPackage({
        type: this.detail.form.type,
        package: cont
      });
      if (res && res.code === 200) {
        this.detail.packageRepeat = res.data.result || false;
      }
      console.log('res >>> ', res);
    },
    
    handleDetailAdd() {
      this.detail.visible = true;
    },
    
    handleDetailEdit(row) {
      this.detail.form = {...row};
      let ids = row.category_ids.split(',');
      let arr = [];
      ids.forEach(i => {
        this.detail.categoryList.forEach(a => {
          if (a.value === parseInt(i)) {
            arr.push([a.value]);
          } else {
            if (a && a.children && a.children.length) {
              a.children.forEach(b => {
                if (b.value === parseInt(i)) {
                  arr.push([a.value, b.value]);
                }
              });
            }
          }
        });
      });
      this.detail.form['category_ids'] = arr;
      this.detail.visible = true;
    },
    
    handleDetailClose() {
      this.detail.visible = false;
      this.detail.packageRepeat = false;
      this.detail.form = {
        id: '',
        name: '',
        category_ids: [],
        type: '',
        dau: '',
        download_url: '',
        comment: '',
        package: '',
        developer_ulk: '',
        wx_appid: '',
        screen_ori: '',
        // sdk_version: 0
      };
      this.$refs['detail'].resetFields();
    },
  
    handleDetailSave() {
      this.$refs['detail'].validate(async (valid) => {
        if (!valid) return;
        let params = {
          ...this.detail.form
        };
        params['package'] = (params.package).trim();
        
        let categoryIdsArr = [];
        this.detail.form.category_ids.forEach(v => {
          if (v && v[1]) {
            categoryIdsArr.push(v[1]);
          } else {
            categoryIdsArr.push(v[0]);
          }
        });
        params['category_ids'] = categoryIdsArr.join();
        
        let res = null;
        if (this.detail.form.id) {
          res = await mediaEdit(params);
        } else {
          res = await mediaAdd(params);
        }

        if (res && res.code === 200) {
          this.$message.success('操作成功');
          this.handleDetailClose();
          this.getList();
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";
@import "~@/assets/css/filter.scss";
</style>
<style lang="scss">
.app_cascader{
  input{height: 32px !important;}
}
.el-tag.el-tag--info{max-width: 100px;}
</style>
